export const useGetNextPaymentDateTranslationKeys = {
  paymentsNextPayment: 'payments.next-payment',
  paymentsInProgress: 'payments.in-progress',

  paymentRegularNextPayment: 'payment.regular-next-payment',
}
